import { render, staticRenderFns } from "./HallEventManagement.vue?vue&type=template&id=4ffd2870&scoped=true&"
import script from "./HallEventManagement.vue?vue&type=script&lang=js&"
export * from "./HallEventManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd2870",
  null
  
)

export default component.exports